const base = {
  url: 'http://ysxl.tjopt.com:9090'
  // url: '/api' // 前端本地调试

}

export default base
